var SENTRY_RELEASE;SENTRY_RELEASE={name: "Exa", version: "1.2.40"};